import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import AOS from "aos";  // Import AOS
import "aos/dist/aos.css";  // Import AOS styles

const PageSection2 = () => {
  // Initialize AOS
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Adjust duration as needed
  }, []);

  return (
    <Box
      sx={{
        position: "relative",
        color: "#fff",
        padding: "4rem 2rem",
        // backgroundImage: "url('https://i.postimg.cc/QCcBxS9T/d80bbd51bcd963d16ca2b93a3fe32a15.jpg')", // Replace with your actual background image URL
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(246, 242, 242, 0.6)", // Darker overlay for better visibility
          zIndex: 1,
        }}
      ></Box>

      <Box sx={{ position: "relative", zIndex: 2, maxWidth: "1200px", margin: "0 auto" }}>
        {/* Heading with animation */}
        <Typography
          variant="h3"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "2rem",
            color: "black",
            fontFamily: '"Montserrat", sans-serif',
          }}
          data-aos="fade-up" // Fade-up animation
        >
          Who we are?
        </Typography>

        {/* Subheading with animation */}
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: "3rem",
            color: "black",
          }}
          data-aos="fade-up" // Fade-up animation with delay
          data-aos-delay="200"
        >
          An Advanced Trading Company Capturing The Needs of the Moment
        </Typography>

        {/* Content Section with animation */}
        <Typography
          variant="body1"
          sx={{
            marginBottom: "2rem",
            textAlign: "justify",
            lineHeight: "1.8",
            color: "black",
          }}
          data-aos="fade-up" // Fade-up animation
          data-aos-delay="400"
        >
          We are a CGL Holding Company, which is GCC-based Investment Company having roots
          predominantly in trading and distribution in Dubai and all over UAE. Since its founding 2
          decades ago in UAE, CGL GENERAL TRADING LLC has become the leading distributor of food
          and non-food products all over UAE. With our head office situated in Dubai, we have
          expanded our horizons progressively, diversifying into other sectors as well. <br />
          <br />
          We streamlined our operations bringing all businesses under the umbrella of CGL Holdings.
          This helped us in increasing our productivity, quality, and customer satisfaction 10
          folds. We import products from other countries based on their quality since we are not
          ready to sacrifice our product quality. We are planning to expand our distribution
          worldwide in the upcoming years.
        </Typography>
      </Box>
    </Box>
  );
};

export default PageSection2;
